function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useMemo } from 'react';
import { compact } from 'lodash-es';
import { Callout, Typography } from 'seagull';
import { getServiceChangeBullets } from "../../../../business-logic/amendmentsLogic";
import ServicePanel from "../../../../components/ServicePanel/ServicePanel";
import { useFeatureFlags } from "../../../../hooks/useFeatureFlags";
import { getAccountingDetails } from "../../../../integrations/Accounting/accounting.utils";
import { serviceModel } from "../../../../models";
import { Accounting } from "../../../../types/api.model";
import AmendmentChangesInAgreementView from "./AmendmentChangesInAgreementView";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function getIntegratedClassName(qboClasses, integratedClassId) {
  if (!qboClasses || !integratedClassId) return null;
  const qboClass = qboClasses.find(_ref => {
    let {
      id
    } = _ref;
    return id === integratedClassId;
  });
  if (!qboClass) return null;
  return qboClass.name;
}
export default function AgreementServiceInstance(props) {
  const {
    service,
    idx,
    serviceDetailsProps,
    qboClasses
  } = props;
  const {
    SERVICE_TEMPLATE_BUNDLE = false
  } = useFeatureFlags();
  const approvalMethod = serviceModel.approvalMethod(service);
  const autoApprovalDate = approvalMethod ? approvalMethod.autoApprovalDate() : null;
  const integratedClassId = serviceModel.integratedClassId(service);
  const integratedClassName = getIntegratedClassName(qboClasses, integratedClassId);
  const changeBullets = useMemo(() => serviceModel.isCompleted(service.status) ? [] : getServiceChangeBullets(service, SERVICE_TEMPLATE_BUNDLE), [service, SERVICE_TEMPLATE_BUNDLE]);
  return /*#__PURE__*/_jsx(ServicePanel, _objectSpread(_objectSpread({
    context: "agreement",
    isReadOnly: true,
    showBulletPoints: true,
    error: false,
    service: service,
    idx: idx
  }, serviceDetailsProps), {}, {
    additionalSections: compact([integratedClassName && {
      disableBorder: true,
      value: /*#__PURE__*/_jsxs(Callout, {
        "data-testid": "service-".concat(idx, "-qbo-class-callout"),
        children: ["When syncing invoices to ", getAccountingDetails(Accounting.QBO).fullName, ", the assigned class is set to", ' ', /*#__PURE__*/_jsx(Typography, {
          as: "span",
          weight: "bold",
          children: integratedClassName
        }), ". This indication is not visible to your client."]
      })
    }]),
    footer: changeBullets.length > 0 && /*#__PURE__*/_jsx(AmendmentChangesInAgreementView, {
      items: changeBullets,
      autoApprovalDate: autoApprovalDate,
      existingNote: serviceModel.note(service),
      testid: "service-".concat(idx, "-changes")
    })
  }));
}